import React, { useEffect, useRef, useState } from 'react'

function NewsCompony() {
  return (
    <div className='c-News-Compony'>
        <div className='News-Compony'>
            <div className='about-C-item handleWidthItem newsText'>
                <p className='title-about'> News and articles </p>
                <div className='textJustify'> In this section, follow the latest news and articles related to the stone and iron industry. Provides up-to-date information on market fluctuations, new technologies, and important trends in these industries </div>
                <div className='btn-abotu'> Lorem ipsum  </div>
            </div>
            <div className='about-C-item handleWidthItem'> 
               <Slider />
            </div>
        </div>
    </div>
  )
}

export default NewsCompony

const images  = [
    {
        ID: 1 ,
        src:"image/News-ahan.jpg",
        title: "Iron industry efforts to reduce carbon",
        discription: "The global iron and steel industries are transitioning to lower carbon emissions to comply with the Paris climate agreement",
    },
    {
        ID: 2 ,
        src:"image/News-sang.jpg",
        title: "Sustainability in the stone industry",
        discription: "In the stone sector, the demand for sustainable resources and environmentally friendly production methods is increasing",
    },
    {
        ID: 3 ,
        src:"image//News-ahan-1.jpg",
        title: "The golden season of buying iron has arrived",
        discription: "The price of iron ore faced a significant decrease on Sunday and it seems that the market is on the path of correction",
    },
    // {
    //     ID: 4 ,
    //     src:"image/cat-2-4.jpg",
    //     title: "Lorem ipsum dolor sit amet 4",
    //     discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 4",
    // },
    // {
    //     ID: 5 ,
    //     src:"image/cat-2-5.jpg",
    //     title: "Lorem ipsum dolor sit amet 5",
    //     discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 5",
    // },
    // {
    //     ID: 6 ,
    //     src:"image/cat-2-6.jpg",
    //     title: "Lorem ipsum dolor sit amet 6",
    //     discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 6",
    // },
    // {
    //     ID: 7 ,
    //     src:"image/cat-2-7.jpg",
    //     title: "Lorem ipsum dolor sit amet 7",
    //     discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 7",
    // },
    // {
    //     ID: 8 ,
    //     src:"image/cat-2-8.jpg",
    //     title: "Lorem ipsum dolor sit amet 8",
    //     discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 8",
    // },
  ];

// function Slider(){
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const sliderRef = useRef(null);
//     const slides = [...images , ...images , ...images]

//     const calculateSlideWidth = () => {
//         const slide = sliderRef.current.children[0];
//         const slideWidth = slide.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(slide).marginRight);
        
//         return slideWidth + gap;
//     };

//     const slideNext = () => {
//         if (currentSlide < images.length - 1) {
//             setCurrentSlide(currentSlide + 1);
//         } else {

//             setCurrentSlide(0); // بازگشت به اولین اسلاید
//         }
//     };

//     const slidePrev = () => {
//         if (currentSlide > 0) {
//             setCurrentSlide(currentSlide - 1);
//         } else {
//             setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
//         }
//     };

//     useEffect(() => {
//         const interval = setInterval(() => {
//             slideNext();
//         }, 5000); // هر 5 ثانیه

//         return () => clearInterval(interval); // تمیزکاری
//     }, [currentSlide]);

//     useEffect(() => {
//         const offset = -calculateSlideWidth() * currentSlide;
//         sliderRef.current.style.transform = `translateX(${offset}px)`;
//     }, [currentSlide]);

//     useEffect(() => {
//         const handleResize = () => {
//             const offset = -calculateSlideWidth() * currentSlide;
//             sliderRef.current.style.transform = `translateX(${offset}px)`;
//         };
//         window.addEventListener('resize', handleResize);

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [currentSlide]);

//     return (
//       <div className="slider-container">
//       <div className="slider"  ref={sliderRef}>
//         {slides.map((item , index) => (
//           <div key={index} className="slide">
//             <img src={item.src} alt=""/>
//             <div className='c-textimageSlider'></div>
//             <div className='textimageSlider'>
//                     <h3>{item.title}</h3>
//                     <p> {item.discription} </p>
//                 </div>
//           </div>
//         ))}
//       </div>
//       <button className="prev" onClick={slidePrev}>&#10094;</button>
//       <button className="next" onClick={slideNext}>&#10095;</button>
//     </div>
//     );
// };

// function Slider() {
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const sliderRef = useRef(null);
//     const slides = [...images, ...images, ...images];
  
//     let startX = 0;
//     let endX = 0;
  
//     const calculateSlideWidth = () => {
//         const slide = sliderRef.current.children[0];
//         const slideWidth = slide.offsetWidth;
//         const gap = parseFloat(window.getComputedStyle(slide).marginRight);
  
//         return slideWidth + gap;
//     };
  
//     const slideNext = () => {
//         if (currentSlide < images.length - 1) {
//             setCurrentSlide(currentSlide + 1);
//         } else {
//             setCurrentSlide(0); // بازگشت به اولین اسلاید
//         }
//     };
  
//     const slidePrev = () => {
//         if (currentSlide > 0) {
//             setCurrentSlide(currentSlide - 1);
//         } else {
//             setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
//         }
//     };
  
//     // مدیریت حرکت انگشت برای اسلاید
//     const handleTouchStart = (e) => {
//         console.log("handleTouchStart" , e.touches[0].clientX);
        
//         startX = e.touches[0].clientX;
//     };
  
//     const handleTouchMove = (e) => {
//         console.log("handleTouchMove" , e.touches[0].clientX);

//         endX = e.touches[0].clientX;
//     };
  
//     const handleTouchEnd = () => {
//         console.log("handleTouchEnd");


//         const swipeDistance = startX - endX;
//         if (swipeDistance > 50) {
//             // سوایپ به چپ: به اسلاید بعدی برو
//             slideNext();
//         } else if (swipeDistance < -50) {
//             // سوایپ به راست: به اسلاید قبلی برو
//             slidePrev();
//         }
//     };
  
//     // useEffect(() => {
//     //     const interval = setInterval(() => {
//     //         slideNext();
//     //     }, 5000); // هر 5 ثانیه
  
//     //     return () => clearInterval(interval); // تمیزکاری
//     // }, [currentSlide]);
  
//     useEffect(() => {
//         const offset = -calculateSlideWidth() * currentSlide;
//         sliderRef.current.style.transform = `translateX(${offset}px)`;
//     }, [currentSlide]);
  
//     useEffect(() => {
//         const handleResize = () => {
//             const offset = -calculateSlideWidth() * currentSlide;
//             sliderRef.current.style.transform = `translateX(${offset}px)`;
//         };
//         window.addEventListener('resize', handleResize);
  
//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [currentSlide]);
  
//     return (
//         <div className="slider-container"
//              onTouchStart={handleTouchStart}
//              onTouchMove={handleTouchMove}
//              onTouchEnd={handleTouchEnd}>
//             <div className="slider" ref={sliderRef}>
//                 {slides.map((item, index) => (
//                     <div key={index} className="slide">
//                         <img src={item.src} alt="" />
//                         <div className='c-textimageSlider'></div>
//                         <div className='textimageSlider'>
//                             <h3>{item.title}</h3>
//                             <p>{item.discription}</p>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//             <button className="prev" onClick={slidePrev}>&#10094;</button>
//             <button className="next" onClick={slideNext}>&#10095;</button>
//         </div>
//     );
// }
  
function Slider() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);
    const slides = [...images];

    let startX = 0;
    let endX = 0;
    let isSwiping = false; // برای تشخیص سوایپ واقعی

    const calculateSlideWidth = () => {
        const slide = sliderRef.current.children[0];
        const slideWidth = slide.offsetWidth;
        const gap = parseFloat(window.getComputedStyle(slide).marginRight);
        return slideWidth + gap;
    };

    const slideNext = () => {
        if (currentSlide < images.length - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            return
            setCurrentSlide(0); // بازگشت به اولین اسلاید
        }
    };

    const slidePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        } else {
            return
            setCurrentSlide(images.length - 1); // حرکت به آخرین اسلاید
        }
    };

    // مدیریت حرکت انگشت برای اسلاید
    const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isSwiping = false; // هنگام شروع تاچ، فرض کنیم که هنوز سوایپ نشده است
    };

    const handleTouchMove = (e) => {
        endX = e.touches[0].clientX;
        const swipeDistance = startX - endX;

        // اگر فاصله بیشتر از 10 پیکسل باشد، سوایپ فعال می‌شود
        if (Math.abs(swipeDistance) > 10) {
            isSwiping = true; // سوایپ فعال است
        }
    };

    const handleTouchEnd = () => {
        if (!isSwiping) {
            // اگر سوایپ فعال نشده، یعنی کاربر فقط کلیک کرده و نیازی به تغییر اسلاید نیست
            return;
        }

        const swipeDistance = startX - endX;
        const threshold = 50; // میزان حداقل فاصله برای تشخیص سوایپ

        if (swipeDistance > threshold) {
            // سوایپ به چپ: به اسلاید بعدی برو
            slideNext();
        } else if (swipeDistance < -threshold) {
            // سوایپ به راست: به اسلاید قبلی برو
            slidePrev();
        }
    };

    useEffect(() => {
        const offset = -calculateSlideWidth() * currentSlide;
        sliderRef.current.style.transform = `translateX(${offset}px)`;
    }, [currentSlide]);

    useEffect(() => {
        const handleResize = () => {
            const offset = -calculateSlideWidth() * currentSlide;
            sliderRef.current.style.transform = `translateX(${offset}px)`;
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [currentSlide]);

    return (
        <div className="slider-container"
             onTouchStart={handleTouchStart}
             onTouchMove={handleTouchMove}
             onTouchEnd={handleTouchEnd}>
            <div className="slider" ref={sliderRef}>
                {slides.map((item, index) => (
                    <div key={index} className="slide">
                        <img src={item.src} alt="" />
                        <div className='c-textimageSlider'></div>
                        <div className='textimageSlider'>
                            <h3 className='handleText'>{item.title}</h3>
                            <p>{item.discription}</p>
                        </div>
                    </div>
                ))}
            </div>
            <button className="prev" onClick={slidePrev}>&#10094;</button>
            <button className="next" onClick={slideNext}>&#10095;</button>
        </div>
    );
}

        

